import '../Css/Header.css';

export default function Header() {
  return (
    <div className="Header">
      <a href="#">Book Now</a>
      <p>
        Contact us at: +971 502614700 (DUBAI), +966599661580 (UAE), +91-6265526339 (INDIA),
        Email:drkhan.onlineclasses@gmail.com
      </p>
    </div>
  );
}
